var map = {
	"../apps/nb-frontend/nb-frontend.module": [
		"./src/app/apps/nb-frontend/nb-frontend.module.ts",
		"common",
		"nb-frontend.module"
	],
	"./apps/lending/lending.module": [
		"./src/app/apps/lending/lending.module.ts",
		"lending.module"
	],
	"./apps/login/login.module": [
		"./src/app/apps/login/login.module.ts",
		"common",
		"login.module"
	],
	"./skeleton/skeleton.module": [
		"./src/app/skeleton/skeleton.module.ts",
		"common",
		"skeleton.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main